import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import {Row, Col} from 'react-bootstrap'
import DayPicker, {DateUtils} from 'react-day-picker'
import localeUtils from 'react-day-picker/moment'
import {control} from'../react/control'
import i18n from '../i18n'
import style from './DayRangePicker.less'

class DayRangePicker extends Component {
    static propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillMount() {
        this.setState({
            toInitial: this.props.value.to || new Date(),
            fromInitial: this.props.value.from || new Date()
        })
    }

    _selectFrom(day) {
        const {value, onChange} = this.props

        if (DateUtils.isSameDay(day, value.from)) {
            var nextValue = {...value, from: null}
            onChange(nextValue)
        } else {
            var nextFrom = day
            var nextTo = value.to && (day < value.to && value.to || day)
            var nextValue = {from: nextFrom, to: nextTo}
            onChange(nextValue)
        }
    }

    _selectTo(day) {
        const {value, onChange} = this.props

        if (DateUtils.isSameDay(day, value.to)) {
            var nextValue = {...value, to: null}
            onChange(nextValue)
        } else if (DateUtils.isSameDay(day, value.from) || day > value.from || !value.from) {
            var nextValue = {...value, ...{to: day}}
            onChange(nextValue)
        }
    }

    render() {
        const {value, onChange} = this.props
        const {fromInitial, toInitial} = this.state

        const modifiers = {
            from: (day) => DateUtils.isSameDay(day, value.from),
            to: (day) => DateUtils.isSameDay(day, value.to),
            range: (day) => {
                if (value.from && value.to) return day > value.from && day < value.to
                if (value.from) return day > value.from
                if (value.to) return day < value.to
                return false
            }
        }

        const fromModifiers = {
            ...modifiers,
            disabled: (day) => day > value.to

        }

        const toModifiers = {
            ...modifiers,
            disabled: (day) => day < value.from
        }

        const display = (day) => (
            <span>{day.getDate()}</span>
        )

        return (
            <div className={style.default}>
                <div className={style.container}>
                    <DayPicker
                        renderDay={display}
                        modifiers={fromModifiers}
                        initialMonth={fromInitial}
                        onDayClick={(e, d) => this._selectFrom(d)}
                        localeUtils={localeUtils}
                        locale={moment.locale()} />
                </div>
                <div className={style.container}>
                    <DayPicker
                        renderDay={display}
                        modifiers={toModifiers}
                        initialMonth={toInitial}
                        onDayClick={(e, d) => this._selectTo(d)}
                        localeUtils={localeUtils}
                        locale={moment.locale()} />
                </div>
            </div>
        )
    }
}

DayRangePicker = control({
    value: {}
})(DayRangePicker)

export default DayRangePicker


// WEBPACK FOOTER //
// ./lib/core/components/DayRangePicker.js